import _ from 'underscore';

export default class AppEventDelegator {
  on(eventName, callback) {
    if (window.App && window.App.on) {
      window.App.on(eventName, callback);
    }
    return this;
  }

  trigger(eventName, params) {
    if (window.App && window.App.trigger) {
      window.App.trigger(eventName, params);
    }
    return this;
  }

  off(eventName, callback) {
    if (window.App && window.App.off) {
      if (_.isUndefined(callback)) {
        window.App.off(eventName);
      } else {
        window.App.off(eventName, callback);
      }
    }
    return this;
  }
}
